// extracted by mini-css-extract-plugin
export default {"wrapper":"A1xItZ","label":"daUQ2x","input":"Qz9mUN","mobile":"x7_huy","button":"xdX7wp","block":"lrj1m1","error":"lghIak","fields":"Db4lPu"};